var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.99995C8.20058 0.90293 5.19377 0.254853 2.93923 2.17509C0.68468 4.09533 0.367271 7.30588 2.13778 9.57695C3.60984 11.4652 8.06479 15.4477 9.52489 16.7366C9.68824 16.8808 9.76992 16.9529 9.86519 16.9813C9.94834 17.006 10.0393 17.006 10.1225 16.9813C10.2178 16.9529 10.2994 16.8808 10.4628 16.7366C11.9229 15.4477 16.3778 11.4652 17.8499 9.57695C19.6204 7.30588 19.3417 4.07513 17.0484 2.17509C14.7551 0.275052 11.7994 0.90293 10 2.99995Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.bd7bfb636c4cc58ea4fc4f049a309392.svg";
export { ForwardRef as ReactComponent };